
import shrink from '~/ZenOne-StoryBook/mixins/shrink'
import localStorage from '~/ZenOne-StoryBook/mixins/localStorage.js'
import {
  FILTER_BY_MANUFACTURER_ID,
  FILTER_BY_DISTRIBUTOR_ID,
} from '~/components/Catalog/CatalogFilters/helper'
export default {
  name: 'ProductCardVendorName',
  mixins: [shrink, localStorage],
  props: {
    distributor: {
      type: Object,
      default() {
        return {}
      },
      required: true,
    },
    manufacturer: {
      type: Object,
      default() {
        return {}
      },
      required: true,
    },
    showBy: {
      type: Boolean,
      default: false,
    },
    isProductTypeManufacturer: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
  computed: {
    name() {
      return (
        this?.[this.isProductTypeManufacturer ? 'manufacturer' : 'distributor']
          ?.name ?? ''
      )
    },
    text() {
      const { name = '', showBy = false } = this
      return !showBy ? name : `by ${name}`
    },
    length() {
      return this.isProductTypeManufacturer ? 30 : 15
    },
  },
  methods: {
    clickHandler() {
      this.setFilter()
    },
    setFilter() {
      const { isProductTypeManufacturer = false } = this
      const filterName = isProductTypeManufacturer
        ? FILTER_BY_MANUFACTURER_ID
        : FILTER_BY_DISTRIBUTOR_ID
      const manufacturerId = this?.manufacturer?.id ?? null
      const distributorId = this?.distributor?.id ?? null
      const value = isProductTypeManufacturer ? manufacturerId : distributorId
      if (!value) return false
      this.$emit('productCardFilterClickHandler', {
        filterName,
        value: [value],
        vendorName: this.name,
      })
    },
  },
}
